'use client';

import { Accordion } from '@ngg/components';
import { StarIcon } from '@ngg/icons';
import type { Dictionary } from 'types';
import type { TReviewsData } from 'types/testFreaks';

import type { MarketConfiguration } from '@/config/markets/const';
import { cn } from '@/lib/utils';

import ReviewContent from '../components/accordion/reviewContent';
import Icon from './icon';

export default function Reviews({
    basedOn,
    reviews,
    dictionary,
    productId,
    title,
    className,
    marketConfig,
}: {
    basedOn: string;
    reviews?: TReviewsData | null;
    dictionary: Dictionary;
    productId: string;
    title: string;
    className?: string;
    marketConfig: MarketConfiguration;
}) {
    if (!reviews) return null;

    const headerTitle = reviews.summary?.your_review_count
        ? `${title} (${reviews.summary?.your_review_count})`
        : title;

    return (
        <Accordion
            defaultOpen={true}
            IconComponent={Icon}
            WrapperComponent="div"
            classNames={{
                wrapper: className,
                button: 'text-left items-center leading-4 p-4 font-medium rounded-none',
                panel: 'p-4',
            }}
            title={headerTitle}>
            {reviews.summary?.your_avg_score ? (
                <div
                    id="product-reviews"
                    className="mb-4 flex items-center border-b border-grey-150 pb-4 text-base">
                    <div className="flex items-center">
                        <div className={cn('mr-1 flex text-xl')}>
                            {[...Array(5)].map((_, i) => (
                                <StarIcon
                                    // eslint-disable-next-line react/no-array-index-key
                                    key={i}
                                    filled={
                                        i <
                                        (reviews?.summary?.your_avg_score || 0)
                                    }
                                />
                            ))}
                        </div>
                    </div>

                    <p>
                        {reviews?.summary?.your_avg_score}&nbsp;
                        {basedOn?.toLowerCase()}&nbsp;
                        {reviews?.summary?.your_review_count}&nbsp;
                        {title?.toLowerCase()}
                    </p>
                </div>
            ) : null}

            <ReviewContent
                marketConfig={marketConfig}
                initialReviews={reviews}
                dictionary={dictionary}
                productId={productId}
            />
        </Accordion>
    );
}
